<template>
  <br />
  <img alt="CAAMS 02" src="CAAMSWheel.png" />
  <h3 aria-label="Welcome to CAAMS" class="h3Hdr">Welcome to CAAMS</h3>
  <div v-if="debugging">
    (visible only if debug flag set to true)
    {{ this.store.healthStatus }}
  </div>
  <div tabindex="0" v-if="this.store.healthStatus.healthyYN == false" class="healthWarning">
    <div class="alert alert-danger">CAAMS is currently undergoing maintenance - please check back in 15 minutes. If this
      issue persists please submit a <a href="#" @click="helpdeskLinkClicked">HelpDesk+ ticket</a></div>
  </div>
  <div class="landingPageContent">
    <p>Civilian Arming Authorization Management System (CAAMS) is an application designed to support the management of
      armed contractors supporting the U.S. Forces and provides compliance management tools as well as reporting
      capabilities. CAAMS offers workflows and business processes to manage the persons, documents, and authorizations
      associated with each contract. </p>

    <p>CAAMS Key Capabilities:</p>
    <ul>
      <li>Automates the key arming authorization process for submitting, reviewing, approving, and executing requests for
        armed contractors. </li>
      <li>Ensures armed civilians and contractors adhere to DoD policy.</li>
      <li>Manages access to contracts/data through user role assignment.</li>
      <li>Enforces collection of all documentation required to receive an arming exception to policy (permission to carry
        a weapon).</li>
      <li>Manages all data and documents required to obtain arming authorization.</li>
      <li>Records all arming authorization requests and tracks investigation statuses.</li>
    </ul>

    <p>To request training materials, or contact the CAAMS team with any questions, please use the Helpdesk and Feedback
      button at the bottom of this page.</p>
  </div>
</template>

<script>
import { store } from "@/store/store.js";

export default {
  name: "LandingPage",
  data() {
    return {
      store,
    };
  },
  computed: {
    debugging() {
      if (this.store.globalDebugging != null) {
        return this.store.globalDebugging;
      }
      else {
        return false;
      }
    }
  },
  methods: {
    helpdeskLinkClicked() {
      window.open('https://www.jccs.gov/HDPlus/Ext/App?Name=CAAMSNG', '_blank', 'resizable=no,scrollbars=yes,status=no,width=800, height=750');
    }
  }
}

</script>

<style scoped>
.healthWarning {
  width: 60%;
  margin-left: auto;
  margin-right: auto;
}

.landingPageContent {
  text-align: left;
  width: 74%;
  margin-left: auto;
  margin-right: auto;
}

.h3Hdr {
  margin-top: 10px;
  margin-bottom: 10px;
}
</style>
